import { useListBoxSection } from '@react-aria/listbox';
import { useSeparator } from '@react-aria/separator';
import React__default from 'react';
import { ListboxOptionInternal } from './listbox-option-internal.component.js';

function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function ListboxSectionInternal({ section , state  }) {
    const { itemProps , headingProps , groupProps  } = useListBoxSection({
        heading: section.rendered,
        'aria-label': section['aria-label']
    });
    const { separatorProps  } = useSeparator({
        elementType: 'li'
    });
    // If the section is not the first, add a separator element.
    // The heading is rendered inside an <li> element, which contains
    // a <ul> with the child items.
    return /*#__PURE__*/ React__default.createElement(React__default.Fragment, null, section.key !== state.collection.getFirstKey() && /*#__PURE__*/ React__default.createElement("li", _object_spread({
        className: "swan-listbox-section-separator"
    }, separatorProps)), /*#__PURE__*/ React__default.createElement("li", itemProps, section.rendered && /*#__PURE__*/ React__default.createElement("span", _object_spread_props(_object_spread({}, headingProps), {
        className: "swan-listbox-section-title"
    }), section.rendered), /*#__PURE__*/ React__default.createElement("ul", _object_spread_props(_object_spread({}, groupProps), {
        className: "swan-listbox-section"
    }), [
        ...section.childNodes
    ].map((node)=>/*#__PURE__*/ React__default.createElement(ListboxOptionInternal, {
            key: node.key,
            item: node,
            state: state
        })))));
}

export { ListboxSectionInternal };
